<template>
  <q-card>
    <q-tabs
      v-model="tabPeriod"
      dense
      class="text-white"
      :active-color="'white'"
      :active-bg-color="activeTabColorFromUtils()"
      :class="
        this.$q.dark.mode === true ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'
      "
      :indicator-color="'white'"
      align="justify"
      narrow-indicator
      outside-arrows
      mobile-arrows
    >
      <q-tab name="daily" label="Daily" no-caps />
      <q-tab name="weekly" label="Weekly" no-caps />
      <q-tab name="monthly" label="Monthly" no-caps />
    </q-tabs>

    <q-separator />

    <q-tab-panels v-model="tabPeriod" animated>
      <q-tab-panel class="q-pa-none" :name="tabPeriod">
        <MarketSummary
          :tabPeriod="tabPeriod"
          :isMarketOn="false"
          @clickSectorRow="onClickSectorRow"
          :marketDaily="marketDaily"
          :marketWeekly="marketWeekly"
          :marketMonthly="marketMonthly"
          :theme="theme"
          @emitSector="
            (emitData) => {
              emitSector = emitData;
            }
          "
        />
      </q-tab-panel>
    </q-tab-panels>
  </q-card>
</template>

<script>
import { ref, watchEffect } from "vue";
import { LocalStorage, useQuasar } from "quasar";
import { useStore } from "vuex";
import useUtils from "src/use/utils";

import MarketSummary from "src/components/MarketSummary.vue";

export default {
  emits: ["clickSectorRow"],
  components: {
    MarketSummary,
  },
  props: {
    allStocks: {
      type: Array,
    },
    marketDaily: { type: Array },
    marketWeekly: { type: Array },
    marketMonthly: { type: Array },
    theme: {
      type: Boolean,
      default: true,
    },
  },
  components: { MarketSummary },
  emits: ["emitSector", "clickSectorRow"],
  setup(props, context) {
    const $q = useQuasar();
    const store = useStore();
    const { chooseTabColor, chooseActiveTabColor } = useUtils();
    const emitSector = ref({});

    const onClickSectorRow = (selectedSectorId) => {
      context.emit("clickSectorRow", selectedSectorId);
    };
    function activeTabColorFromUtils() {
      return chooseActiveTabColor($q.dark.mode, store.state.domain.domain);
    }

    watchEffect(() => {
      const newVal = emitSector.value;
      context.emit("emitSector", newVal);
    });

    return {
      activeTabColorFromUtils,
      tabPeriod: ref("daily"),
      onClickSectorRow,
      emitSector,
    };
  },
};
</script>
